package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_05_19_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes notice fresh air but see no obvious exits.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Some soldiers are traveling in the opposite direction.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As our heroes travel deeper into the Darkway, they notice that the once well-attended torchlight has become more spotty with many torches unlit. Tuesday has always enjoyed adding fire to things not currently on fire, but Caper has told him that some things shouldn’t be on fire, and he doesn’t want to disappoint her. Luckily Caper gives him her approval, and he makes a game out of lighting unlit torches.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Since our heroes left Ybrallan, they have been traveling between towns, spending most nights sleeping in an inn or barracks and eating relatively fresh food when not in inns and taverns. The scale of the Darkway is beginning to sink in and our heroes begin counting rations in their packs. In the evening, Falorn spends some time in quiet meditation to prepare the ability to conjure food and water.")
    }
}
